import * as React from 'react'
import QS from 'qs'
import { observer } from 'mobx-react'
import { RouteChildrenProps } from 'react-router'
import styles from './Logout.sass'

interface Props extends RouteChildrenProps {
  onLogout: (returnUrl: string) => unknown
}

export default observer(function Logout({ onLogout, location }: Props) {
  React.useEffect(() => {
    const query = QS.parse(location.search, { ignoreQueryPrefix: true })
    onLogout(query.redirect_to as string)
  }, [])
  return (
    <div className={styles.root}>
      <div className={styles.emoji}>👋</div>
    </div>
  )
})
